<template>
    <div v-if="themeStore.themeIndex === 3">
        <WithdrawPWCompletion />
    </div>
    <StatusPopup ref="statusRef" />
</template>

<script setup lang="ts">
import StatusPopup from '@/components/common/statusPopup.vue';
import { useThemeStore } from '@/stores/theme';
import WithdrawPWCompletion from '@/themes/themeThree/withdraw/withdrawPWCompletion.vue';

const themeStore = useThemeStore()
</script>
<style scoped>

</style>